__turbopack_context__.v({
  "_cable": "BenefitsSection-module-scss-module__Ac8fja___cable",
  "_finance": "BenefitsSection-module-scss-module__Ac8fja___finance",
  "_tradeIn": "BenefitsSection-module-scss-module__Ac8fja___tradeIn",
  "_warranty": "BenefitsSection-module-scss-module__Ac8fja___warranty",
  "card": "BenefitsSection-module-scss-module__Ac8fja__card",
  "cardContent": "BenefitsSection-module-scss-module__Ac8fja__cardContent",
  "cards": "BenefitsSection-module-scss-module__Ac8fja__cards",
  "root": "BenefitsSection-module-scss-module__Ac8fja__root",
  "title": "BenefitsSection-module-scss-module__Ac8fja__title",
  "tooltip": "BenefitsSection-module-scss-module__Ac8fja__tooltip",
  "tooltipButton": "BenefitsSection-module-scss-module__Ac8fja__tooltipButton",
});
